/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import Widget, { WidgetProps } from './Widget'
import { FormatNumberOptions, useIntl } from 'react-intl'
import { Text } from '@mantine/core'

export type CounterWidgetProps = WidgetProps<number> & {
  options?: FormatNumberOptions
}

function CounterWidget (props: CounterWidgetProps) {
  const { label, options, value } = props
  const intl = useIntl()
  return (
    <Widget
      label={label}
      value={
        <Text size="lg">
          {value != null ? intl.formatNumber(value, options) : null}
        </Text>
      }
    />
  )
}

export default CounterWidget
